import { render } from "./PaymentPolicy.vue?vue&type=template&id=ddd481e4"
import script from "./PaymentPolicy.vue?vue&type=script&lang=js"
export * from "./PaymentPolicy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__